import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';

import {
  type LinkToExistingUnitOperationsActionParams,
  useLinkToExistingUnitOperationsAction,
} from './useLinkToExistingUnitOperationsAction';

export type LinkToExistingUnitOperationsButtonProps = LinkToExistingUnitOperationsActionParams;

/**
 * Legacy full-text "Link to existing" button used by the legacy StudyExecutionHeader (flag-off /
 * out-of-scope studies). The new Mantine header consumes {@link useLinkToExistingUnitOperationsAction}.
 */
export default function LinkToExistingUnitOperationsButton(
  props: LinkToExistingUnitOperationsButtonProps
): JSX.Element {
  const action = useLinkToExistingUnitOperationsAction(props);
  const isDisabled = action.isDisabled ?? false;
  return (
    <Tooltip isDisabled={!isDisabled} text={action.disabledTooltip ?? null}>
      <Button
        dataTestAttrs={action.dataTestAttrs}
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        size={ButtonSize.MEDIUM}
        onClick={action.onSelect}
        text={action.name}
        icon={action.icon}
        disabled={isDisabled}
      />
    </Tooltip>
  );
}
